import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Workspace: A logical grouping for organizing related conversations into projects or collections.',
    name: 'Workspaces',
    partialId: PartialId.Standard.create('workspaces'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
